import { Component } from '@verndale/core';

class SingleLineQuestion extends Component {
  setupDefaults() {
    this.dom = {
      input: this.el.querySelector(
        '.single-line-question__input-container input'
      ),
      button: this.el.querySelector(
        '.single-line-question__input-container button'
      ),
      nextButton: this.el.querySelector(
        '.ceraplus-btn'
      )
    };
  }

  addListeners() {
    const { input, button } = this.dom;
    input.addEventListener('input', this.enableButton.bind(this));
    button.addEventListener('click', this.showNextButton.bind(this));
  }

  enableButton() {
    const { input, button } = this.dom;
    if (input.value > 0) {
      button.disabled = false;
    } else {
      button.disabled = true;
    }
  }

  showNextButton(e){
    e.preventDefault();
    const { nextButton } = this.dom;
    nextButton.hidden = false;
  }
}

export default SingleLineQuestion;
